import { render } from "./SidebarNotice.vue?vue&type=template&id=0b283cfb&scoped=true"
import script from "./SidebarNotice.vue?vue&type=script&lang=js"
export * from "./SidebarNotice.vue?vue&type=script&lang=js"

import "./SidebarNotice.vue?vue&type=style&index=0&id=0b283cfb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b283cfb"]])

export default __exports__